import { Speaker } from "@components/__templates__/EventsDetail/EventsDetail";
import { Fragment } from "react";

const SpeakersSection = (props: { speakers: Speaker[] }) => {
  const { speakers } = props;

  if (!speakers?.length) return null;

  return (
    <dl>
      {speakers.map((speaker, index) => (
        <Fragment key={`speaker-${index}`}>
          <dt>{speaker?.fields?.name}</dt>
          {/* @ts-expect-error type mistmatch */}
          <dd>{speaker?.fields?.link}</dd>
        </Fragment>
      ))}
    </dl>
  );
};

export default SpeakersSection;
